/**
 * Focuses `el` only when nothing else holds the focus. When the element that had it is taken off the page (a dialog
 * closing), the focus falls to the body; a dialog opened since then holds it, and keeps it (#376).
 */
export function focusIfIdle(el: { focus(): void } | null | undefined): void {
  const held = document.activeElement;
  if (!held || held === document.body) el?.focus();
}
